import L from 'leaflet';

import { TramPosition } from "./tram-position";
import { TramStop } from "./tram-stop";
import { ILeafletObject } from "../common/index";
import { Coordinate } from './coordinate';

export class Tram {
    id: number;
    scheduleId: number;
    routeId: number;
    routeNumber: string;
    publicNumber: string;
    state: number;
    position: TramPosition;
    nextStop: TramStop;
    currentStopId: number;
    isReverseTrip: boolean;
}

export class LeafletTram extends Tram implements ILeafletObject {
    private _popup: L.Popup;
    private _marker: L.Marker;
    private _tramClass: string

    get popup(): L.Popup { return this._popup; }
    get marker(): L.Marker { return this._marker; }

    isEnabled: boolean = true;
    isSelected: boolean = false;

    constructor(tram: Tram) {
        super();

        this.id = tram.id;
        this.scheduleId = tram.scheduleId;
        this.routeId = tram.routeId;
        this.routeNumber = tram.routeNumber;
        this.publicNumber = tram.publicNumber;
        this.state = tram.state;
        this.position = tram.position;
        this.nextStop = tram.nextStop;
        this.isReverseTrip = tram.isReverseTrip;

        this._tramClass = `tram-${this.routeNumber}`;

        this.initMarker();
    }

    select(): void {
        this.isSelected = true;
        if (!this._marker._icon)
            return;
        L.DomUtil.addClass(this._marker._icon, 'selected-tram');
    }

    unselect() {
        this.isSelected = false;
        if (!this._marker._icon)
            return;
        L.DomUtil.removeClass(this._marker._icon, 'selected-tram');
    }

    updatePosition(coordinate: Coordinate) {
        this._marker.setLatLng([coordinate.latitude, coordinate.longitude]);
    }

    enable() {
        this.isEnabled = true;
        if (!this._marker._icon)
            return;
        L.DomUtil.removeClass(this._marker._icon, 'disabled-map-object');
    }

    disable() {
        this.isEnabled = false;
        if (!this._marker._icon)
            return;
        L.DomUtil.addClass(this._marker._icon, 'disabled-map-object');
    }

    private initMarker() {
        let position = [
            this.position.coordinate.latitude,
            this.position.coordinate.longitude];
        let icon = L.icon({
            iconUrl: '../../assets/tram.svg',
            iconSize: [23, 23],
            className: ['default-tram', this._tramClass].join(' ')
        });
        let options = {
            icon: icon,
            title: this.publicNumber,
            alt: this.publicNumber,
            riseOnHover: true
        };
        let popupOptions = {
            closeButton: false,
            autoPanPadding: 1
        };
        // this._popup = L.popup(popupOptions)
        //     .setContent(this.publicNumber)
        //     .setLatLng(position);
        this._marker = L.marker(position, options);
        //     .bindPopup(this._popup);
    }
}


// WEBPACK FOOTER //
// D:/programming/Чижик_Api_Site_Sources-Electroline/front/src/app/core/tram.ts